// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-list-item[data-v-5d12a924] {\r\n  min-height: 0 !important;\n}\n.v-expansion-panel[data-v-5d12a924] .v-expansion-panel-header,\r\n.v-expansion-panel[data-v-5d12a924] .v-expansion-panel-content__wrap {\r\n  padding: 0 !important;\n}\n.v-expansion-panel[data-v-5d12a924] .v-expansion-panel-content {\r\n  width: 100%;\n}\r\n/*.row {\r\n  border: solid 1px red;\r\n}\r\n.col {\r\n  border: solid 1px orange;\r\n}*/\r\n", ""]);
// Exports
module.exports = exports;
